//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import InquiryForm from '~/components/search/inquiry/mixins/InquiryForm'

import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, minValue, numeric} from "vuelidate/lib/validators";
import { BFormGroup, BFormRadioGroup, BFormRadio, BFormInput, BFormSelect, BFormTextarea, BFormDatepicker } from 'bootstrap-vue'

export default {

    name: 'InquiryProjectForm',

    mixins: [validationMixin, InquiryForm],

    components: { BFormGroup, BFormRadioGroup, BFormRadio, BFormInput, BFormSelect, BFormTextarea, BFormDatepicker },

    props: {
        project: {
        },
        projectBudgets: {
        },
    },

    data() {
      return {
      }
    },

    validations: {
        project: {
            destinationPitch: {
                required
            },
            destinationDescription: {
                required
            },
            dateStart: {
                required
            },
            dateEnd: {
            },
            duration: {
                required,
                numeric,
                minValue: minValue(1)
            },
            amountGuest: {
                required,
                numeric,
                minValue: minValue(1)
            },
            budget: {
                required
            },
            accommodationRequired: {
                required
            },
        }
    },
}

